import { Api } from "./Api";

let StudentApi = {
    endpoint: "Students/",
}

//Add the Api Mixin
StudentApi = Object.assign({}, Api, StudentApi);

export { StudentApi };
